'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('./_tslib-15827112.js');
require('./getScript.js');
require('axios');
require('./LoginConsent.js');
require('./AuthApi.js');
var Auth = require('./Auth.js');

var GoogleAuth = /** @class */ (function (_super) {
    _tslib.__extends(GoogleAuth, _super);
    function GoogleAuth(_a) {
        var loginGoogleClientId = _a.loginGoogleClientId, props = _tslib.__rest(_a, ["loginGoogleClientId"]);
        var _this = _super.call(this, _tslib.__assign({}, props)) || this;
        _this._GApiInit = function () {
            return new Promise(function (resolve, reject) {
                //@ts-ignore
                gapi.load('auth2', function () {
                    //@ts-ignore
                    _this.auth2 = gapi.auth2.init({
                        client_id: _this.loginGoogleClientId + '.apps.googleusercontent.com',
                        scope: 'profile email'
                    });
                    resolve();
                });
            });
        };
        _this.LoadGoogleSDK = function () {
            return _this.LoadSdk('https://apis.google.com/js/platform.js')
                .then(_this._GApiInit);
        };
        _this.SignIn = function () {
            return _this._grantOfflineAccess().then(_this._GoogleLoginCallback, _this._GoogleLoginOnErrorCallback);
        };
        _this._GoogleLoginOnErrorCallback = function (response) {
            if (response && response.error && response.error !== "popup_closed_by_user") {
                return Promise.reject(new Error(response.error));
            }
        };
        _this._GoogleLoginCallback = function (authResult) {
            if (!authResult['code']) {
                return Promise.reject(new Error('There was an error'));
            }
            var params = { Code: authResult['code'] };
            return _this.$AuthApi.LoginGoogle(params)
                .then(function (response) { return _this._authCallback(response.data, 'google', response.status === 201); })
                .catch(console.error);
        };
        _this._grantOfflineAccess = function () { return _this.auth2.grantOfflineAccess(); };
        _this.auth2 = null;
        _this.loginGoogleClientId = loginGoogleClientId;
        return _this;
    }
    return GoogleAuth;
}(Auth.default));

exports.default = GoogleAuth;
//# sourceMappingURL=GoogleAuth.js.map
